export default {
  itemStyle: {
    normal: {
      borderWidth: '0',
      borderColor: '#ffffff'
    },
    emphasis: {
      borderWidth: '0',
      borderColor: '#ffffff'
    }
  }
};